.headerCellContent {
  display: flex;
  align-items: center;
  height: 30px;
  position: relative;
}